import { sdkRequest } from '@eventbrite/http';
import { Organizer } from '../types';

export const getDefaultOrganizer = (
    organizationId: string,
): Promise<Organizer> | undefined => {
    if (organizationId == '') return undefined;

    const options = {
        method: 'GET',
    };

    return sdkRequest(
        `/organizations/${organizationId}/organizers/default/`,
        options,
    );
};
